import Header from "./includes/Header";
import Footer from "./includes/Footer";
import { Outlet, useLocation } from "react-router-dom";

function Layout() {
  const location = useLocation();
  const isCustomTracking = location.pathname.startsWith("/custom-tracking");

  if (isCustomTracking) {
    return <Outlet />;
  }

  return (
    <>
      <Header /> 

      <Outlet /> 

      <Footer /> 
    </>
  );
}

export default Layout;
